export default __webpack_public_path__ + "static/media/Driver_HTB.2d5f15fb.md";